import { useState, useEffect, useContext } from 'react';

import '../assets/css/feather.css';
import '../assets/css/Style.css';
import HelpIcon from '../assets/images/icons/help-circle.svg';
import { GetPayLoad, SetPayLoad, RemovePayLoad } from '../services/PayLoadStorage';
import { useNavigate, NavLink } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import Schedulepayment from "../components/schedulepayment";
import { LanguageContext } from '../contexts/LanguageContext';
import parse from 'html-react-parser';
import { getApiService } from '../services/ApiService';
import Cookies from 'js-cookie';
import { handleFiservLogin } from "../services/FiservLoginService";

const Landing = () => {

    const navigate = useNavigate();
    const [payNow, setPayNow] = useState(false);
    const [activeCases, setActiveCases] = useState([]);
    const { pageContent } = useContext(LanguageContext);
    const [landingPageContent, setLandingPageContent] = useState([]);
    const [schedulePaymentContent, setSchedulePaymentContent] = useState([]);

    useEffect(() => {
        if (pageContent?.landing) {
            setLandingPageContent(pageContent.landing);
        }
    }, [pageContent]);

    useEffect(() => {
        // Check if multiplePolicies is empty and set it from the payload
       const storedPolicies = GetPayLoad('ActiveCases');
       localStorage.removeItem('IsChecked'); // Clear IsChecked from session storage on landing page load
        if (storedPolicies) {
            setActiveCases(storedPolicies || []);
        }
        if(GetPayLoad('PayLoad')) {
            RemovePayLoad('PayLoad'); // Clear existing payload if it exists
        }
    }, []);

    const appData = localStorage.getItem('appData');
    const decodedAppData = appData ? JSON.parse(atob(appData)) : null;
    const siteCd =  Object.values(decodedAppData).find(obj => 'site_cd' in obj)?.site_cd || '';
    
    // Function to set custom payload based on keyData
    const handleSetCustomPayLoad = (keyData) => {    
        if(keyData !=''){
           if(decodedAppData){
                const matchedItems = Object.values(decodedAppData).filter(item => item.cim === keyData.parent_cim);
                const firstMatch = matchedItems.length > 0 ? matchedItems[0] : null;
                if(GetPayLoad('PayLoad')) {
                    RemovePayLoad('PayLoad'); // Clear existing payload if it exists
                }
                SetPayLoad('PayLoad', btoa(JSON.stringify(firstMatch))); // Set new payload
            }
        }
    }

    // Handle click on case number link and redirect to overview page
    const handleOverviewClick = (item) => {
        handleSetCustomPayLoad(item);
        localStorage.setItem('IsChecked', true);
    };

    // Handle click on amount due link to open schedule payment modal
    const handleSchedulePaymentClick = (item) => {
        handleSetCustomPayLoad(item);
        if (Cookies.get('owningCarrier') !== 'C4') {
            setPayNow(true);
        }
        // if the carrier is C4 then redirect to fiserv login
        if (Cookies.get('owningCarrier') === 'C4') {
            handleFiservLogin();
        }
    };
    
    // Handle close action for the schedule payment modal
    const handleCloseSchedulePaymentModal = (e) => {
        e.preventDefault()
        setPayNow(false);
        RemovePayLoad('PayLoad'); // Clear payload when modal is closed
    }

   const lang = Cookies.get('lang') || 'eng';

    useEffect(() => {
        if(siteCd !== '') {
            const page = 'billing'; // Assuming the page is 'billing' for schedule payment
            const baseUrl = process.env.REACT_APP_API_BASE_URL;
            const headers = {
                        "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
                        "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
                        };
            const targetUrl = process.env.REACT_APP_API_CMS_CONTENT_ENDPOINT;            
            getApiService(
                baseUrl,
                targetUrl,
                {
                    page: page,
                    site_cd: siteCd,
                    lang: lang
                },
                headers
            )
            .then((response) => {
                if(response?.data && response.data.status === 'SUCCESS'){
                    const result = response.data.data;
                    setSchedulePaymentContent(result);
                }
            })
            .catch((error) =>{
                console.log(error);
            })
        }
    }, [siteCd, lang]);
    
    // This component is a placeholder for the landing page.
    return (        
                <div className="conatiner-fluid content-inner mt-n5 py-0">
                    <div className="card px-3 mt-3">
                        <div className="col-12 mt-2 justify-content-center">
                            <div className="card-body p-3 p-md-4 p-xl-3">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="bd-example table-responsive d-grid-tbl billhistory-table">
                                            <table className="table table-striped billinghistory-thead">
                                                <thead className="">
                                                    <tr>
                                                    <th scope="col">{landingPageContent?.landing_case_number_label}</th>
                                                    <th scope="col">{landingPageContent?.landing_coverage_label}</th>
                                                    <th scope="col">{landingPageContent?.landing_dependent_label}</th>
                                                    <th scope="col">{landingPageContent?.landing_status_label}</th>
                                                    <th scope="col">{landingPageContent?.landing_amountdue_label}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    { activeCases && activeCases.length > 0 ?
                                                        activeCases?.map((policy, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <NavLink to="/overview" className="text-decoration-underline" onClick={() => handleOverviewClick(policy)}>   
                                                                        {policy.case_num}
                                                                    </NavLink>
                                                                </td>
                                                                <td>{policy.coverage}</td>
                                                                <td>{policy.dependents}</td>
                                                                <td>
                                                                    <label className="d-block">
                                                                        <button className={`btn btn-success btn-sm removeCursorStyle ${policy?.status?.toLowerCase() !== 'active' ? 'btn-danger' : ''}`}>{policy.status}</button>
                                                                    </label>
                                                                </td>
                                                                <td
                                                                    style={{ cursor: policy?.status?.toLowerCase() === 'active' ? 'pointer' : 'default' }}
                                                                    onClick={ policy?.status?.toLowerCase() === 'active' ? () => handleSchedulePaymentClick(policy) : undefined }
                                                                    className={ policy?.status?.toLowerCase() === 'active' ? 'text-decoration-underline' : '' }
                                                                >
                                                                    {policy.amount_due}
                                                                </td>
                                                            </tr>
                                                        )) :
                                                        <tr>
                                                            <td colspan="5" className="text-center">No policies available</td>
                                                        </tr>
                                                    }                                        
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="col-12 mt-2">
                                        <h4><img className="me-2" src={HelpIcon} alt="Cigna" width="18"/> {landingPageContent?.landing_help_text}</h4>
                                        {landingPageContent?.landing_member_notes && parse(landingPageContent?.landing_member_notes)}
                                    </div>
                                    {payNow && (<Modal size='xl' show={payNow} onHide={() => { setPayNow() }} className="schedulepayment">
                                                    <Schedulepayment handleCloseSchedulePaymentModal={handleCloseSchedulePaymentModal} contentFromExternal={schedulePaymentContent} />
                                                </Modal>)}
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    );
}
export default Landing;